"use client"

import {
  type ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react"

const PortalContainerContext = createContext<HTMLElement | null>(null)

export function PortalContainerProvider({
  container,
  children,
}: {
  container: HTMLElement | null
  children: ReactNode
}) {
  return (
    <PortalContainerContext.Provider value={container}>
      {children}
    </PortalContainerContext.Provider>
  )
}

export function PortalContainerByIdProvider({
  id,
  children,
}: {
  id: string
  children: ReactNode
}) {
  const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(
    null
  )

  useEffect(() => {
    setPortalContainer(document.getElementById(id))
  }, [id])

  return (
    <PortalContainerProvider container={portalContainer}>
      {children}
    </PortalContainerProvider>
  )
}

export function usePortalContainer() {
  return useContext(PortalContainerContext)
}
